// Règles du tableau de suivi et des contacts patients du matériel médical.

export function formatFollowUpPatient(row) {
    return `${row.patientNom || ""} ${row.patientPrenom || ""}`.trim() || row.patient || "";
}

export function formatContactPatient(row) {
    return `${row.nom || ""} ${row.prenom || ""}`.trim() || row.patient || "";
}

// Un contact se rattache à sa ligne de suivi ; un contact ancien, sans ligne, se rattache par nom et prénom.
export function contactMatchesFollowUp(contact, followUp) {
    if (contact.followUpId != null) return contact.followUpId === followUp.id;
    const contactIdentity = `${contact.nom || ""} ${contact.prenom || ""}`.trim().toLocaleLowerCase("fr");
    return Boolean(contactIdentity) && contactIdentity === formatFollowUpPatient(followUp).toLocaleLowerCase("fr");
}

export function displayMergeValue(value) {
    if (value == null || value === "") return "Vide";
    if (typeof value === "boolean") return value ? "Oui" : "Non";
    return String(value);
}

// Ligne enregistrée après une modification concurrente : la fusion automatique, la version distante et, pour
// chaque champ en conflit, la valeur choisie (« mine » ou « other »).
export function resolveMergeConflict({ local, remote, merged, conflicts, choices }) {
    const resolved = { ...merged, version: remote.version };
    conflicts.forEach(field => {
        resolved[field] = choices[field] === "mine" ? local[field] : remote[field];
    });
    resolved.patient = `${resolved.patientNom || ""} ${resolved.patientPrenom || ""}`.trim();
    return resolved;
}

export function isPastDate(value, today = new Date()) {
    if (!value) return false;
    const todayValue = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
    return value < todayValue;
}
